import getConfig from 'next/config'

export const isomorphicLog = async (...args: any[]) => {
  if (typeof window === 'undefined') {
    // Load logger module only on the server side
    const { logger } = await import('server/utils/logger')
    if (logger) {
      logger.info(...args)
      return
    }
  }

  // For the client-side, or if import failed on the server side
  const { publicRuntimeConfig } = getConfig()

  if (publicRuntimeConfig.releaseEnv !== 'production') {
    // Log to console for non-production environments
    console.log(...args)
  }
}
